<div class="delivery-details-card">

    <div class="card-header">
        <h2 class="card-title">Delivery Details</h2>
    </div>

    <div class="card-content">

        <table class="details-table">
            <tr>
                <td><strong>Date</strong></td>
                <td [title]="emailResponse?.Date">{{ emailResponse?.Date }}</td>
            </tr>
            <tr>
                <td><strong>Country</strong></td>
                <td [title]="emailResponse?.Country">{{ emailResponse?.Country }}</td>
            </tr>
            <tr>
                <td><strong>Account ID</strong></td>
                <td [title]="emailResponse?.AccountId">{{ emailResponse?.AccountId }}</td>
            </tr>
            <tr>
                <td><strong>Account Name</strong></td>
                <td [title]="emailResponse?.AccountName">{{ emailResponse?.AccountName }}</td>
            </tr>
            <tr>
                <td><strong>Contact Name</strong></td>
                <td [title]="emailResponse?.ContactName">{{ emailResponse?.ContactName }}</td>
            </tr>
            <tr>
                <td><strong>Email</strong></td>
                <td [title]="emailResponse?.CustomerContactEmail">{{ emailResponse?.CustomerContactEmail }}</td>
            </tr>
            <tr>
                <td><strong>Notification Title</strong></td>
                <td [title]="emailResponse?.NotificationTitle">{{ emailResponse?.NotificationTitle }}</td>
            </tr>
            <tr>
                <td><strong>Notification Type</strong></td>
                <td [title]="emailResponse?.NotificationType">{{ emailResponse?.NotificationType }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Failure Reason</strong></td>
                <td [title]="emailResponse?.DeliveryFailedReason">{{ emailResponse?.DeliveryFailedReason }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Failure description</strong></td>
                <td [title]="emailResponse?.DeliveryFailureDescription">{{ emailResponse?.DeliveryFailureDescription }}</td>
            </tr>
            <tr>
                <td><strong>Delivery details</strong></td>
                <td [title]="emailResponse?.DeliveryDetails">{{ emailResponse?.DeliveryDetails }}</td>
            </tr>
            <tr>
                <td><strong>Delivery Status</strong></td>
                <td>
                    <span 
                        [ngClass]="{ 
                            'delivered-status': emailResponse?.DeliveryStatus === 'Delivered', 
                            'failed-status': emailResponse?.DeliveryStatus === 'Failed' 
                        }" 
                        class="status-chip" 
                        [title]="emailResponse?.DeliveryStatus === 'Delivered'? 'Delivered' : 'Failed'">
                        {{ emailResponse?.DeliveryStatus }}
                    </span>
                </td>
            </tr>
            <tr>
                <td><strong>Resend</strong></td>
                <td>
                    <span 
                        *ngIf="emailResponse?.IsResend === true" 
                        class="resend-chip resend-yes" 
                        [title]="'Yes'">
                        Yes
                    </span>
                    <span 
                        *ngIf="emailResponse?.IsResend === false" 
                        class="resend-chip resend-no" 
                        [title]="'No'">
                        No
                    </span>
                </td>
            </tr>
        </table>

    </div>
  
    <div class="card-actions">
        <owc-button variant="primary" (click)="close()">Close</owc-button>
    </div>

</div>